import React, { HTMLProps } from 'react';

const DownOutlined: React.FC<HTMLProps<SVGAElement>> = ({ className }) => {
  return (
    <svg
      className={`${className || ''} down_outlined`}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="18" height="18" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_35_424"
            transform="translate(-0.0479452) scale(0.00856164 0.0078125)"
          />
        </pattern>
        <image
          id="image0_35_424"
          width="128"
          height="128"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABmJLR0QA/wD/AP+gvaeTAAAEV0lEQVR4nO3dv4sjZQDG8e8bBdmDJIeFSjJTLCxoexAVLIWzsBBsRA6UOxHsBMG/wM5/wE4RUQtbq/PutBBBRMFCEa80k5V1tzg3Iom5y2uxOdBlNzNvMj/e953n02yRSTLwfDO7SZEFERERERERERERERERERERERERERERERERERERERERERHxmil64GAwuNTpdF4D9oA58NV8Pn//8PDwr8rOTnLt7e31ZrPZG8CzwAXg9nK5/HB/f/+bIvcvEoBJkuRd4O0zjh9ba1+YTCY/Op21lGL1ovwcGJ6+zVr73mQyeRO4t+4xHsh7kuFw+JYx5h3OjqVvjHm53+/fOj4+3i964rK9NE1HxphbwCNn3W6MebLb7c6n0+nX6x5n7RUgSZId4Hegn3M+d4wxl8fj8fc5x0kJ0jQdWWtvABdzDv17Nps9dnR0ND3vgE7OAzxN/vgAF621N9I0HRU4VrbgMD7AhZ2dnWfWHZAXwMOFz+wkgptJkjzlcB9xMBgMLllrr1NsfACWy2Vv3e1rAzDG/Fb0iVb6wHVdCcqXpumo0+l8iduLMnfDvHcBJkmSX4DHXZ4U/U1QKsfL/n/dzrLsCcCed0DerwBrrb0K/OP4xPp1UJJNLvsrd40xr7NmfMgPgMlk8q219hXgruMJ9IEvFMHmVu/zb+J42efkvf+18Xi89i0gOHwSOBwOXzLGfAI86HgyfwLPZVn2neP9Wm3L8a9mWfZxkYMLBwCKoC51jQ+OAYAiqFqd48MGAYAiqErd48OGAYAiKFsT48MWAYAiKEtT48OWAYAi2FaT40MJAYAi2FTT40NJAYAicOXD+FBiAKAIivJlfCg5AFAEeXwaHyoIABTBeXwbHyoKABTBaT6ODxUGAIrgPl/Hh4oDAEXg8/hQQwDQ3gh8Hx9qCgDaF0EI40ONAUB7IghlfKg5AIg/gpDGhwYCgHgjCG18aCgAiC+CEMeHBgOAeCIIdXxoOAAIP4KQxwcPAoBwIwh9fPAkAAgvghjGB48CgHAiiGV88CwA8D+CmMYHDwMAfyOIbXzwNADwL4IYxwePAwB/Ioh1fPA8AGg+gpjHhwACgOYiiH18CCQAqD+CNowPAQUA9UXQlvEhsACg+gjaND4EGABUF0HbxodAA4DyI2jj+BBwAFBeBG0dHwIPALaPYLlcLto6PkQQAECSJFeAjyjw9fen3Fn9dP0SxnvAq1mWfep4P+9EEQBsdSVwFcUr/z7XV4y3ptPpz91u91djzIsU+AbUDUU1PkQUAFQeQXTjQ2QBQGURRDk+RBgAlB5BtONDpAFAaRFEPT5EHABsHUH040PkAcDGEbRifGhBAOAcQWvGh5YEAIUjaNX40KIA4CSCXq/3E/A88NDpm4ErWZZ9Vv+ZNSeaj4Jd7O7uPrpYLK4BI07+qdIPi8Xig4ODgz8aPjUREREREREREREREREREREREREREREREREREREREREREZH/+xcH194Gapd8ygAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>
  );
};

export default DownOutlined;
